const { getElement, getElements } = window.BAO.Utils

class MediaControls extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.wrapper = this.closest(this.externalEls?.wrapper.selector)
    this.video = getElement(this.externalEls?.video.selector, {
      context: this.closest(this.externalEls?.wrapper.selector),
    })

    this.playButton = getElement('[data-action="play"]', {
      context: this.wrapper,
    })
    this.muteButton = getElement('[data-action="mute"]', {
      context: this.wrapper,
    })
    this.playButtonWrapper = getElements('.med-MediaControls_IconWrapper', {
      context: this.playButton,
    })
    this.muteButtonWrapper = getElements('.med-MediaControls_IconWrapper', {
      context: this.muteButton,
    })
  }

  static get styles () {
    return `:host { display: block; }`
  }

  static get requiredExternalElements () {
    return ['video', 'wrapper']
  }

  static get requiredElements () {
    return ['button']
  }

  connectedCallback () {
    this.classList.add('med-MediaControls-visible')

    this.muteButton.addEventListener('click', evt => this.toggleSoundState(evt))
    this.playButton.addEventListener('click', evt => this.togglePlayState(evt))
  }

  togglePlayState () {
    this.video.paused ? this.video.play() : this.video.pause()

    this.playButtonWrapper.forEach(icon => {
      icon.classList.toggle('med-MediaControls_IconWrapper-hidden')
    })
  }

  toggleSoundState () {
    const isMuted = this.video.muted
    this.video.muted = !isMuted

    this.muteButtonWrapper.forEach(icon => {
      icon.classList.toggle('med-MediaControls_IconWrapper-hidden')
    })
  }
}

if (!customElements.get('media-controls')) {
  customElements.define('media-controls', MediaControls)
}
